// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProgressBar_Container__8nqUa","Timer":"ProgressBar_Timer__Z5kLS","Progress":"ProgressBar_Progress__8V2Vu","Percentage":"ProgressBar_Percentage__30x6O"};